import { Injectable } from '@angular/core';
import moment from 'moment';
import { ApiService, T4TurboOrderService, UIService } from 't4core';


@Injectable({
  providedIn: 'root',
})
export class OrderService {

  constructor(private Api: ApiService, private UI: UIService, private orderSvc: T4TurboOrderService) { }

  public async SendCustomer2T4(id: number) {
    var token = this.UI.beginLoading("TO.ActiveContracts.msgSending2T4", "Contecting T4", null);
    var ret = await this.orderSvc.UpdateT4Station(id);
    if (ret.IsSuccess) {
      this.UI.snackBar("Customer was sent successfully!", null, 5000);
    } else {
      this.UI.alert(
        "TO.ActiveContracts.headUpdateStationFailed",
        "Station could not be updated in T4",
        ret.Message,
        null);
    }
    this.UI.loaderCompleted(token);
  }

  public async SendObject2T4(id: number) {
    var token = this.UI.beginLoading("TO.ActiveContracts.msgSending2T4", "Contacting T4", null);
    var ret = await this.orderSvc.UpdateT4Object(id);
    if (ret.IsSuccess) {
      this.UI.snackBar("Object was sent successfully!", null, 5000);
    } else {
      this.UI.alert(
        "TO.ActiveContracts.headUpdateObjectFailed",
        "Object could not be sent to T4",
        ret.Message,
        null);
    }
    this.UI.loaderCompleted(token);
  }

    
}
